import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import ArrowRightAboveIcon from 'packages/kakapo-ui-kit/assets/icons/ArrowRightAboveIcon';
import Color from 'packages/kakapo-ui-kit/components/common/Color';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';
import PopoverTarget from 'packages/kakapo-ui-kit/components/popovers/PopoverTarget';

import SettingsItem from '../../generic/SettingsItem';
import { Spinner, Tags } from '@treams/treams-ui';
import { useState } from 'react';

const TooltipTitle = styled.div`
	border-top: 1px solid ${(props) => props.theme.colors.lightBlue};
	padding-top: 10px;
	margin: 0px -20px;
	margin-top: 10px !important;
	margin-bottom: -5px;
	text-align: center;
`;

export default function JobCompetency(props: {
	jobTitle: graphql.JobTitle;
	jobCompetency: graphql.JobCompetency;
	jobLevelID?: string,
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const levelOptions = props.jobCompetency.competency.levels.map((level, idx) => ({
		title: localize(level.level.title).text,
		value: idx.toString()
	}));

	const currentLevel = props.jobCompetency.competency.levels[props.jobCompetency.competencyLevel];

	const [attach, { loading: updating }] = graphql.useAttachJobCompetencyMutation();
	const [detach, { loading }] = graphql.useDetachJobCompetencyMutation();

	return (
		<SettingsItem
			loading={loading}
			item={{ ...props.jobCompetency, isArchived: false }}
			title={(competency) => localize(competency.competency.title).text}
			link={(competency) => `/settings/competencies/${competency.competency.id}`}
			onArchive={async () => {
				await detach({
					variables: {
						input: {
							jobTitleID: props.jobTitle.id,
							competencyID: props.jobCompetency.competency.id,
							jobLevelID: props.jobCompetency.level?.id,
						},
					},
				});
			}}
			onRefresh={() => {}}
			accessory={
				<Flex alignItems="center">
					{updating && <Spinner mr={2} />}
					<PopoverTarget
						content={
							<Box style={{ padding: 20 }}>
								<Paragraph color="slateBlue">
									<QuillText
										quill={localize(currentLevel.criteria ?? [])?.text}
										placeholder={t('evaluation.submission.competency.levels.noDescription')}
									/>
								</Paragraph>
							</Box>
						}
					>
						<Flex alignItems="center">
							<Tags.Item.Select
								enabled={!updating}
								options={levelOptions}
								selectedValue={props.jobCompetency.competencyLevel.toString()}
								onChange={async (newValue) => {
									if (newValue) {
										await attach({
											variables: {
												input: {
													jobTitleID: props.jobTitle.id,
													jobLevelID: props.jobLevelID,
													competencyID: props.jobCompetency.competency.id!,
													competencyLevel: parseInt(newValue),
												},
											},
										});
									}
								}}
							/>
						</Flex>
					</PopoverTarget>
				</Flex>
			}
		/>
	);
}
